<template>
  <v-card>
    <v-card-title v-if="this.$route.path != '/accumulative'">
      <span>{{ title }}</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-row>
        <!-- Sidebar (10%) -->
        <!-- Contenido de la barra lateral -->
        <v-col cols="3" class="sidebar">
          <v-card class="scrollable-card">
            <v-card-title>Seleccionar variables</v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item-group
                  v-model="selected_variables"
                  multiple
                  color="blue"
                  @change="addDataToVariable" 
                >
                <!-- @change="addDataToVariable" -->
                  <v-list-item
                    v-for="(item, index) in available_variables"
                    :key="index"
                    :value="item.id_variable"
                  >
                    <v-list-item-title class="body-2"
                      >{{ item.id_variable }} -
                      {{ item.variable }}</v-list-item-title
                    >
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="9">
          <template v-if="!selected_variables.length">
                <div>
                  Seleccione al menos una variable para visualizar la gráfica.
                </div>
              </template>
              <template
                v-else-if="!loading && !chartData?.datasets?.length"
              >
      
              <div>
                  No se han encontrado datos para las fechas seleccionadas.
                </div>
              </template>
              <v-row v-if="loading">
                  <v-col>
                    <v-progress-linear
                      indeterminate
                      color="primary"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              <template v-else>
                </template>
          <GraficoLinea 
          v-if="hayDatosDeGrafica"
          :loading="loading"
          :chartData="chartData"
          :chartOptions="chartOptions"
          ></GraficoLinea>
       
        </v-col>

      </v-row>
      <v-row>
        <v-btn v-if="hayDatosDeGrafica"  block @click="downloadData">
          <v-icon>mdi-file-download</v-icon>Descargar Excel
        </v-btn>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
          v-if="hayDatosDeGrafica"
            :headers="headers"
            :items="items"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Tabla de Variables</v-toolbar-title>
              </v-toolbar>
            </template>

          </v-data-table>
        </v-col>
      </v-row>
      <v-btn v-if="hayDatosDeGrafica"  block @click="downloadData">
        <v-icon>mdi-file-download</v-icon>Descargar Excel
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment-timezone";
import * as XLSX from "xlsx";

import { mapGetters, mapActions, mapState } from "vuex";

import LineChart from "@/utils/LineChart.vue";

import GraficoLinea from "@/components/GraficoLinea.vue";

export default {
  components: {
    LineChart, GraficoLinea
  },

  props: {
    title: String,
    available_variables: Array,
    initial_variables: Array,
    id_ciclo: Number,
    id_maquina: Number,
    fabricacion: Number
  },

  data() {
    return {
      selected_variables: [],

      unidades:{
        'timeUnit':'second',
         timeStep: 1
      },



      chartData: {},
      tableData:[],

      table_data: [],
      headers: [],
      items: [],

      loading: false,
    };
  },

  computed: {
    ...mapState(['versionAcumulado']),
   
    hayDatosDeGrafica(){
      return  (Object.keys(this.chartData).length > 0)
    },
    table_header() {
      const headers = this.selected_variables?.map((v) => ({
        text: `${v?.name}`,
        value: `${v?.id_variable}`,
      }));
      headers.unshift({ text: "Fecha", value: "read_at_group" });
      return headers;
    },

    chartOptions(){
      const options = {
        plugins: {
          title: {
            display: false,
            text: 'Gráfico de Diámetro y Tiempo',
          },
          legend: {
            display: true,
            position: 'top',
            labels: {
              font: {
                size: 14,
              },
              usePointStyle: true,
            },
          },
          annotation: {}, // Aquí puedes agregar tus anotaciones
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true,
              },
              mode: 'x',
              pan: {
                enabled: true,
              },
              drag: {
                enabled: true,
              },
            },
          },
          // tooltip: {
          //   enabled: true,
          //   mode: 'nearest',
          //   intersect: false,
          // },
          tooltips: {
            callbacks: {
              label: function (tooltipItem) {
                let label =
                  this.chartData?.datasets[tooltipItem.datasetIndex]?.label || "";
                if (label) {
                  label += ":ssss";
                }
                label += tooltipItem.yLabel;
                return "label";
              },
            },
          },
        },
        responsive: true,
        animation: false, // Desactivar animación
        maintainAspectRatio: false,
        scales: {
          x: {
            type: 'time', // Escala de tiempo para el eje X
            time: {
              unit: this.unidades.timeUnit, // Unidad mínima de tiempo para los ticks
              timeStep: this.unidades.timeStep, // Unidad mínima de tiempo para los ticks

              displayFormats: {
                second: 'DD/MM/YYYY HH:mm:ss', // Formato para mostrar segundos
                minute: 'DD/MM/YYYY HH:mm',    // Formato para minutos
                hour: 'DD/MM/YYYY HH:mm',      // Formato para horas
              },
              tooltipFormat: 'DD/MM/YYYY HH:mm:ss', // Formato para el tooltip
            },
            title: {
              display: true,
              text: 'Tiempo (Día, Minuto, Segundo)', // Título del eje X
            },
            ticks: {
              source: 'auto', // Generar ticks automáticamente basados en los datos
            },
          },
          y: {
            beginAtZero: true, // Asegura que la escala comience en 0
            suggestedMin: 0,           // Define el mínimo explícitamente como 0
            type: 'linear', // Escala lineal para el eje Y
          },
         
        },
        interaction: {
          mode: "index",
          intersect: false,
        },
        elements: {
          point: {
            radius: 0, // Establece el radio de los puntos a 0
          },
        },
      }// fin options

       // Agregar y2 si is_fabricacion es true
      if (this.is_fabricacion) {
        options.scales.y2 = {
          suggestedMin: 400,
          suggestedMax: 1100,
          position: "right",
        };
      }
      return options;

    }


        
  
  },

  methods: {
    ...mapGetters("utils", ["getInitDateFilter", "getEndDateFilter"]),
    ...mapActions(["getHistoricosAcumulados", "getHistoricosProcesados"]),

    limpiarDatos(){
      this.chartData={}
    },
    getDiff(chartDataActual){
 // if(this.hayDatosDeGrafica) {
      const ultimoPunto = chartDataActual.chartData.datasets[0].data[chartDataActual.chartData.datasets[0].data.length-1].x
      const primerPunto = chartDataActual.chartData.datasets[0].data[0].x

      // Crear objetos Date válidos
      const ultimoPuntoDate = new Date(ultimoPunto);
      const primerPuntoDate = new Date(primerPunto);

      // Calcular la diferencia en milisegundos
      const timeDiff = (ultimoPuntoDate - primerPuntoDate)/1000;

      console.log(ultimoPunto, primerPunto, timeDiff)
      if (timeDiff >= 60 && timeDiff < 3600) {
        this.unidades={
          'timeUnit':'second',
          'timeStep': 60
        }
      } else if (timeDiff >= 3600 && timeDiff < 86400) {
        this.unidades={
          'timeUnit':'minute',
          'timeStep': 3600
        }
      } else if (timeDiff >= 86400) {
        this.unidades={
          'timeUnit':'hour',
          'timeStep': 86400
        }
      }

      return timeDiff

    },

    // async addDataToVariable() {
    //   console.log("addDataToVariable");
    //   this.loading = true;
    //   this.chartData = {};
      
    //   if (this.selected_variables.length == 0) {
    //     this.loading = false;
    //     return;
    //   }

    //   // Incrementar el contador de solicitudes activas
    //   this.activeRequests = (this.activeRequests || 0) + 1;

    //   let params = {
    //     id_maquina: this.id_maquina,
    //     is_fabrication: this.$route.path == "/fabrication",
    //     id_ciclo: this.id_ciclo,
    //     variables: JSON.stringify(this.selected_variables),
    //     initDate: this.getInitDateFilter(),
    //     endDate: this.getEndDateFilter(),
    //   };

    //   console.log(params);

    //   try {
    //     const chartDataActual = await (this.$route.path == "/accumulative"
    //       ? this.getHistoricosAcumulados(params)
    //       : this.getHistoricosProcesados(params));

    //     console.log("YA HAY DATOS!");
    //     console.log(chartDataActual);

    //     if (chartDataActual.chartData.datasets.length == 0) return;

    //     this.unidades["diferencia"] = this.getDiff(chartDataActual);
    //     this.chartData = chartDataActual.chartData;
        
    //     const tabla = chartDataActual.tableData;
    //     this.tableData = tabla;
    //     this.items = tabla.items;
    //     this.headers = tabla.headers;
    //   } catch (error) {
    //     console.error("Error al obtener datos", error);
    //   } finally {
    //     // Decrementar el contador de solicitudes activas
    //     this.activeRequests--;

    //     // Solo desactivar `loading` si no hay más solicitudes en curso
    //     if (this.activeRequests === 0) {
    //       this.loading = false;
    //     }
    //   }
    // },

    async addDataToVariable() {
  console.log("addDataToVariable");
  this.loading = true;
  this.chartData = {};

  if (this.selected_variables.length == 0) {
    this.loading = false;
    return;
  }

  // Incrementar el contador de solicitudes activas
  this.activeRequests = (this.activeRequests || 0) + 1;

  let params = {
    id_maquina: this.id_maquina,
    is_fabrication: this.$route.path == "/fabrication",
    id_ciclo: this.id_ciclo,
    variables: JSON.stringify(this.selected_variables),
    initDate: this.getInitDateFilter(),
    endDate: this.getEndDateFilter(),
  };

  // console.log(params);

  console.log(params);
  let chartDataActual;
  try {
    if (this.$route.path == "/accumulative") {
      // if(process.env.VUE_APP_VERSION_ACUMULADO==1)
      if(this.versionAcumulado==2)
      {
        params = {
          ids: this.selected_variables.join(','),
          fecha_inicio : this.getInitDateFilter(),
          fecha_fin : this.getEndDateFilter(),
        }
      }
    
      chartDataActual = await this.$store.dispatch("getHistoricosAcumulados", params);
    }
    else {
      chartDataActual = await this.$store.dispatch("getHistoricosProcesados", params);
    
    }
    // Llamar a Vuex para obtener datos

    if( this.$route.path == "/fabrication") {
      chartDataActual = await this.$store.dispatch("getHistoricosProcesados", params);
    } else {
      if (this.$route.path == "/history") {
        chartDataActual = await this.$store.dispatch("getHistoricosProcesados", params);
      } else {
        chartDataActual = await this.$store.dispatch("getHistoricosAcumulados", params);
      }
    }

    if (!chartDataActual || chartDataActual.chartData.datasets.length === 0) return;

    console.log("YA HAY DATOS!", chartDataActual);

    this.unidades["diferencia"] = this.getDiff(chartDataActual);
    this.chartData = chartDataActual.chartData;

    const tabla = chartDataActual.tableData;
    this.tableData = tabla;
    this.items = tabla.items;
    this.headers = tabla.headers;
  } catch (error) {
    console.error("Error al obtener datos", error);
  } finally {
    // Decrementar el contador de solicitudes activas
    this.activeRequests--;

    if (this.activeRequests === 0) {
      this.loading = false;
    }
  }
},


    // downloadData(){
    //   console.log(this.tableData)
    //   // const tablaTransformada = this.formatNumbers(this.tableData.items)
    //   const tablaTransformada = this.tableData.items
    //         // Convertir los datos en una hoja de trabajo (worksheet)
    //   const worksheet = XLSX.utils.json_to_sheet(tablaTransformada);

    //   // Crear un libro de trabajo (workbook)
    //   const workbook = XLSX.utils.book_new();
    //   XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");

    //   // Guardar el archivo Excel
    //   const outputFileName = "datos.xlsx";
    //   XLSX.writeFile(workbook, outputFileName);
    // },

    downloadData() {
    console.log(this.tableData);

    // Transformar los números asegurando que solo tengan 2 decimales con coma
    const tablaTransformada = this.tableData.items.map(item => {
        let newItem = { ...item };

        Object.keys(newItem).forEach(key => {
            if (!isNaN(parseFloat(newItem[key])) && isFinite(newItem[key])) {
                newItem[key] = parseFloat(newItem[key]).toFixed(2).replace('.', ',');
            }
        });

        return newItem;
    });

    // Convertir los datos en una hoja de trabajo (worksheet)
    const worksheet = XLSX.utils.json_to_sheet(tablaTransformada);

    // Crear un libro de trabajo (workbook)
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");

    // Guardar el archivo Excel
    const outputFileName = "datos.xlsx";
    XLSX.writeFile(workbook, outputFileName);
},

    // downloadData() {
    //   if (this.table_header.length > 1) {
    //     const ws = XLSX.utils.aoa_to_sheet([
    //       this.table_header?.map((header) => header.text),
    //     ]);
    //     this.table_data.forEach((item) => {
    //       const row = this.table_header?.map((header) =>
    //         item[header.value] !== null ? item[header.value] : ""
    //       );
    //       XLSX.utils.sheet_add_aoa(ws, [row], { origin: -1 });
    //     });
    //     const wb = XLSX.utils.book_new();

    //     XLSX.utils.book_append_sheet(wb, ws, "Data");
    //     const file_name = "datos_variables_seleccionadas";
    //     XLSX.writeFile(wb, file_name + ".xlsx");
    //   }
    // },

    onRenderComplete() {
      this.$nextTick(() => {
        this.loading = false;
      });
    },

    close() {
      this.selected_variables = [];
      this.chartData={}
      this.$emit("close");
    },
  },

  mounted() {
    console.log("MONTADO MULTIVARIABLE")
   
  },

  watch: {
    initial_variables: {
      immediate: true,
      handler(newVal) {
        console.log("nuevos valores!!!")
        console.log(newVal)
        console.log("nuevos available_variables!!!")
        console.log(this.available_variables)
        if (newVal?.length > 0) {
          this.selected_variables = this.available_variables.filter((av) =>
            newVal.includes(av)
          );
          if(this.initial_variables) {
            console.log("INICIALES!!!!!!")
            console.log(this.initial_variables)
            this.selected_variables = JSON.parse(JSON.stringify(this.initial_variables))
            this.addDataToVariable();
          } else {
            console.log("SIN INICIALES")
          }
          this.addDataToVariable();
        }
      },
    },
  },
};
</script>

<style>
.scrollable-card {
  max-height: 600px;
  overflow-y: auto;
}
</style>